import { Button, Select, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { Members, QuizRules } from "src/static/interface";
import {
  GetMembersConfig,
  GetMembersExcelConfig,
  GetQuizRulesListConfig,
} from "src/service/api";
import type { ColumnsType } from "antd/es/table";
import { useSearchParams } from "react-router-dom";
import SearchFilter from "src/components/filter/SearchFilter";
import { MainContext } from "src/context";
import { DownloadOutlined } from "@ant-design/icons";
import { openLink } from "src/utils";

function MembersPage() {
  const [searchParams] = useSearchParams();
  const [dataSource, setDataSource] = useState<Members[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { Option } = Select;
  const { handleMakeParams } = useContext(MainContext);
  const [quizRules, setQuizRules] = useState<QuizRules[]>();
  const quizRuleId = searchParams.get("quizRuleId");
  const search = searchParams.get("search");

  const getFunc = () => {
    // Only make API call if quizRuleId is available
    if (!quizRuleId || quizRuleId === "null" || quizRuleId === "undefined") {
      setDataSource([]);
      return;
    }

    setLoading(true);
    GetMembersConfig(
      `?quizRuleId=${quizRuleId}${search ? `&search=${search}` : ``}`
    )
      .then((res) => {
        setDataSource(res.data);
        window.scrollTo(0, 0);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getFunc();
  }, [searchParams, quizRuleId, search]);

  const getFuncQuizRules = () => {
    GetQuizRulesListConfig().then((res) => {
      setQuizRules(res.data);
    });
  };

  useEffect(() => {
    getFuncQuizRules();
  }, []);

  useEffect(() => {
    if (quizRules) {
      handleMakeParams?.("quizRuleId", `${quizRules![0]?.id}`);
    }
  }, [quizRules]);

  const handleChange = (val: string) => {
    handleMakeParams?.("quizRuleId", val);
  };

  const columns: ColumnsType<Members> = [
    {
      title: "Kodi",
      dataIndex: "code",
      key: "code",
      width: 70,
    },
    {
      title: "Universitet nomi",
      key: "university",
      dataIndex: "university",
    },
    {
      title: "O'qituvchilar soni",
      dataIndex: "teacherCount",
      align: "center",
      key: "teacherCount",
    },
    {
      title: "Talabalar soni",
      dataIndex: "studentCount",
      align: "center",
      key: "studentCount",
    },
    {
      title: "Jami",
      dataIndex: "participantCount",
      align: "right",
      key: "participantCount",
    },
  ];
  const downloadExcel = () => {
    setLoadingExcel(true);
    GetMembersExcelConfig(
      `?quizRuleId=${quizRuleId}${search ? `&search=${search}` : ``}`
    )
      .then((res) => {
        openLink(URL.createObjectURL(res.blob), "Qatnashgan talabalar soni universitetlar kesimida excel");
      })
      .finally(() => setLoadingExcel(false));
  };

  return (
    <div>
      <div className="layout-content-header">
        <p>Qatnashgan talabalar soni universitetlar kesimida</p>
        <div className="right">
          <Select
            value={quizRuleId}
            allowClear={false}
            showSearch
            onChange={handleChange}
            style={{ width: 350 }}
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {quizRules?.map((item) => (
              <Option key={item.id} value={String(item.id)}>
                {item.theme}
              </Option>
            ))}
          </Select>
          <SearchFilter />
          <Button
            onClick={downloadExcel}
            icon={<DownloadOutlined />}
            type="primary"
            className="excel"
            loading={loadingExcel}
          >
            Excel yuklash
          </Button>
        </div>
      </div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        loading={loading}
        scroll={{ y: 550 }}
        bordered
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <strong>Jami</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="center">
                <strong>
                  {dataSource.reduce((acc, curr) => acc + curr.teacherCount, 0)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="center">
                <strong>
                  {dataSource.reduce((acc, curr) => acc + curr.studentCount, 0)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="right">
                <strong>
                  {dataSource.reduce(
                    (acc, curr) => acc + curr.participantCount,
                    0
                  )}
                </strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </div>
  );
}

export default MembersPage;
